export { default } from './MarketingCarousel';
